<template>
  <div class="flashed-messages">
    <transition-group name="fade" tag="div">
      <p
        v-for="msg in flashedMessages"
        :key="msg.id"
        :class="msg.msgType"
      >
        {{ msg.msg }}
        <span class="close-x" @click="close(msg)">&times;</span>
      </p>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'FlashedMessages',
  computed: {
    ...mapState({
      flashedMessages: state => state.Notifications.messages,
    }),
  },
  methods: {
    ...mapActions({
      close: 'Notifications/clearMessage',
    }),
  },
};
</script>

<style lang="scss" scoped>
.flashed-messages {
  position: absolute;
  top: 50px;
  width: 100%;
  text-align: center;
  z-index: 3;
  pointer-events: none;
  p {
    pointer-events: all;
    background-color: white;
    width: fit-content;
    margin: 0 auto 8px;
    padding: 8px;
    border-radius: 4px;
    font-size: 14pt;
    box-shadow: 3px 3px 4px rgba(0.3, 0.3, 0.3, 0.4);
    &.fade-leave-active {
      transition: opacity 1s;
    }
    &.fade-leave-to {
      opacity: 0;
    }
    &.success {
      background-color: rgb(90, 218, 90);
    }
  }
  .close-x {
    margin-left: 8px;
    border-radius: 25px;
    padding: 3px 9px;
    transition: background-color 0.5s;
    cursor: pointer;
    &:hover {
      background-color: rgb(199, 196, 196);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FlashedMessages.vue